import { useEffect } from "react";
import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { z } from "zod";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/convex-api";
import { organizationContext } from "@/lib/organization-context";
import { organizationRoute } from "@/lib/app-routes";

export const Route = createFileRoute("/_authenticated/")({
  validateSearch: z.object({
    billing: z.enum(["inactive"]).optional(),
    cmdk: z.literal("1").optional(),
    modal: z
      .enum(["org_settings", "user_settings", "project_settings"])
      .optional(),
  }),
  component: AuthenticatedIndexRedirect,
});

function AuthenticatedIndexRedirect() {
  const navigate = useNavigate();
  const search = useSearch({ from: "/_authenticated/" });
  const organizations = useQuery(api.organizations.listForUser, {});

  useEffect(() => {
    if (!organizations || organizations.length === 0) {
      return;
    }
    const preferredOrganizationId = organizationContext.getSelectedOrganizationId();
    const selectedOrganization =
      organizations.find((organization) => organization.id === preferredOrganizationId) ??
      organizations[0];
    if (!selectedOrganization) {
      return;
    }
    organizationContext.setSelectedOrganizationId(selectedOrganization.id);
    void navigate({
      to: organizationRoute,
      params: { orgSlug: selectedOrganization.slug },
      search,
      replace: true,
    });
  }, [navigate, organizations, search]);

  return (
    <div className="flex h-full items-center justify-center">
      <Loader2 className="size-5 animate-spin text-muted-foreground" />
    </div>
  );
}
